import { render, staticRenderFns } from "./locTypeJournal.vue?vue&type=template&id=5c8a0f8e&"
import script from "./locTypeJournal.vue?vue&type=script&lang=js&"
export * from "./locTypeJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports